<template lang="pug">
#event-form
  loading-bar(v-if="settings.submitting")
  spinner(v-if="settings.loading")
  div(v-else)
    .form-header
      h1 {{ event.title }}
      small.has-text-grey Updated: {{ form.updated_at | date('MMMM Do, YYYY h:mm A') }}
    div(v-if="!form.id")
      .notification.has-text-centered
        a.button
          b-icon(icon="plus")
          span Add a Section
    .form-blocks
      form-block(
        v-for="(block, $index) in form.blocks"
        :index="$index"
        :key="block.id"
        :value="block"
      )
</template>

<script>
import { mapGetters } from 'vuex';
import FormBlock from '@/components/form/FormBlock';
import LoadingBar from '@/components/LoadingBar';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'event-form',
  components: {
    FormBlock,
    LoadingBar,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      event: getters.GET_EVENT,
      form: getters.GET_FORM,
      formRefresh: getters.GET_FORM_REFRESH,
    }),
  },
  async created() {
    this.settings.loading = true;
    await this.$store.dispatch(actions.DO_GET_EVENT, {
      id: this.id,
    });
    if (this.event.form_id) {
      await this.$store.dispatch(actions.DO_GET_FORM, {
        id: this.event.form_id,
        zoom: this.zoom,
      });
      this.settings.loading = false;
    } else {
      this.settings.loading = false;
    }
  },
  data() {
    return {
      settings: {
        loading: false,
        submitting: false,
      },
      zoom: 'block',
    };
  },
  methods: {
    async refresh() {
      this.settings.submitting = true;
      await this.$store.dispatch(actions.DO_GET_FORM, {
        id: this.event.form_id,
        zoom: 'block',
      });
      this.$store.commit(mutations.SET_FORM_REFRESH, false);
      setTimeout(() => {
        this.settings.submitting = false;
      }, 1000);
    },
  },
  props: {
    id: {
      type: String,
    },
  },
  watch: {
    formRefresh(val) {
      if (val) {
        this.refresh();
      }
    },
  },
};
</script>

<style lang="scss">
#event-form {
  background-color: $white-ter;
  padding-bottom: 3rem;
  min-height: 100vh;
  .loading-bar {
    position: fixed;
  }
  .spinner {
    margin-top: 0;
    position: relative;
    top: 60px;
  }
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 1.5rem 0 1.5rem;
    h1 {
      font-weight: 500;
      font-size: 1.5rem;
    }
  }
  .form-blocks {
    padding: 1.5rem;
    .form-block {
      // transition: box-shadow 0.35s ease-in-out, transform 0.35s ease-in-out;
      &:hover {
        // box-shadow: 0 3px 30px rgba(0,0,0,0.05);
      }
      &:not(:last-child) {
        margin-bottom: 2rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EventForm.vue